import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import { buttons as Buttons, Icon } from '@breezeway/brzw-components';
import { viewport } from '@common/utils';

import './quick_actions.scss';

const ALIGN_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right',
};

class QuickActions extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      outViewport: {},
    };

    this.quickActionsRef = React.createRef();
    this.quickActionsDropdownRef = React.createRef();

    this.handleClick = this.handleClick.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
    this.setOutViewPortData = this.setOutViewPortData.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((!prevState.open && this.state.open) || (prevState.open && !this.state.open)) {
      this.setOutViewPortData();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  setOutViewPortData() {
    this.setState({
      outViewport: viewport.detectOutOfViewport(this.quickActionsDropdownRef),
    });
  }

  toggleDropdown() {
    this.setState({
      open: !this.state.open,
    });
  }

  handleClick(e) {
    if (!_.isEmpty(this.quickActionsRef) && !this.quickActionsRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  renderDropdown() {
    const { actions, align } = this.props;
    const { outViewport } = this.state;

    const items = _.map(actions, (action, index) => (
      <div
        className="quick-actions__action"
        key={index}
        onClick={action.action}
        role="button"
        tabIndex={0}
      >
        <div className="quick-actions__action-label">{action.label}</div>
        <Icon className="quick-actions__action-icon" iconName="right" />
      </div>
    ));

    return (
      <div
        ref={this.quickActionsDropdownRef}
        className={classnames('quick-actions__dropdown', {
          'quick-actions__dropdown--left': outViewport.left || align === ALIGN_POSITIONS.LEFT,
          'quick-actions__dropdown--right': outViewport.right || align === ALIGN_POSITIONS.RIGHT,
        })}
      >
        {items}
      </div>
    );
  }

  render() {
    const { buttonTheme, icon, className } = this.props;
    const { open } = this.state;

    return (
      <div className={classnames('quick-actions', className)} ref={this.quickActionsRef}>
        <Buttons.IconButton
          iconName={icon}
          onClick={this.toggleDropdown}
          size={Buttons.constants.BUTTON_SIZES.ICON_BIG}
          theme={buttonTheme}
          className="quick-actions__dropdown-button"
        />
        {open && this.renderDropdown()}
      </div>
    );
  }
}

QuickActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      action: PropTypes.func,
    }),
  ).isRequired,
  align: PropTypes.oneOf(['left', 'right']),
  buttonTheme: PropTypes.oneOf(_.values(Buttons.constants.BUTTON_THEMES)),
  className: PropTypes.string,
  icon: PropTypes.string,
};

QuickActions.defaultProps = {
  align: 'right',
  buttonTheme: Buttons.constants.BUTTON_THEMES.LINK,
  className: '',
  icon: 'ellipsis',
};

export default QuickActions;
